import axios from "axios";

export const getIssueReports = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/issueReportManagement/getIssueReports",
      body
    );
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getIssueReport = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/issueReportManagement/getIssueReport",
      body
    );

    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const createIssueReport = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/issueReportManagement/createIssueReport",
      body
    );
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const updateIssueReport = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/issueReportManagement/updateIssueReport",
      body
    );
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const deleteIssueReport = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/issueReportManagement/deleteIssueReport",
      body
    );
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
